import { render, staticRenderFns } from "./SidebarProductLoyalty.vue?vue&type=template&id=a1690872&scoped=true&"
import script from "./SidebarProductLoyalty.vue?vue&type=script&lang=js&"
export * from "./SidebarProductLoyalty.vue?vue&type=script&lang=js&"
import style0 from "./SidebarProductLoyalty.vue?vue&type=style&index=0&id=a1690872&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1690872",
  null
  
)

export default component.exports